import base from "../baseurl";
import token from "../getTk";

const Show = async (Uuid) => {
  const tokenA = token.get();

  const api = base.extend({
    hooks: {
      beforeRequest: [
        (request) => {
          request.headers.set("jwt", `${tokenA}`);
        },
      ],
    },
  });

  const status = await api.post("industrial-parks/index", { json: {} }).json();
  return status.data;
};

export default Show;
